import disableConsoleLogging from './Helpers/disableConsoleLogging';

disableConsoleLogging();

import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { msalConfig } from './Components/authConfig';

import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ClickAnalyticsPlugin } from '@microsoft/applicationinsights-clickanalytics-js';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from "history";
const browserHistory = createBrowserHistory();

import { SignInStateProvider } from './Components/signInState';
import { ConfigProvider } from './context/ConfigContext';
import { FeatureFlagsLoader } from './Components/TenantFeaturesLoader';
import App from './App';

import './index.css';

const msalInstance = new PublicClientApplication(msalConfig);

if (process.env.REACT_APP_MS_APPLICATION_INSIGHTS) {
  const reactPlugin = new ReactPlugin();
  const clickPluginInstance = new ClickAnalyticsPlugin();
  const clickPluginConfig = {
    autoCapture: true
  };
  const appInsights = new ApplicationInsights({
    config: {
        connectionString: process.env.REACT_APP_MS_APPLICATION_INSIGHTS,
        extensions: [reactPlugin, clickPluginInstance],
        extensionConfig: {
          [reactPlugin.identifier]: { history: browserHistory },
          [clickPluginInstance.identifier]: clickPluginConfig
        }
    }
  });
  appInsights.loadAppInsights();
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ConfigProvider>
      <MsalProvider instance={msalInstance}>
        <SignInStateProvider>
          <FeatureFlagsLoader>
            <App />
          </FeatureFlagsLoader>
        </SignInStateProvider>
      </MsalProvider>
    </ConfigProvider>
  </React.StrictMode>
);
